import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CountdownService {
  private readonly counter: BehaviorSubject<number> = new BehaviorSubject(0);
  private readonly finished: Subject<void> = new Subject();

  private dueTime!: number;

  public readonly remainingTime$: Observable<number> = this.counter.asObservable();

  private registerStart(period: number): void {
    this.counter.next(period);
    this.dueTime = new Date().getTime() + period * 1000;
  }

  private get remainingTime(): number {
    return Math.ceil((this.dueTime - new Date().getTime()) / 1000);
  }

  start(period: number): void {
    this.registerStart(period);
    interval(1000)
      .pipe(
        takeUntil(this.finished),
        map(() => this.remainingTime),
      )
      .subscribe(remainingTime => {
        if (remainingTime > 0) {
          this.counter.next(remainingTime);
        } else {
          this.counter.next(0);
          this.finished.next();
        }
      });
  }
}
